export enum SeriesPatternStateEnum {
  NOT_USED = 'not_used',
  IN_USE = 'in_use',
  EXPIRED = 'expired',
}
